import React from "react";
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import {useTranslation} from "react-i18next";

const PasswordChecker = ({password}) => {
    const {t} = useTranslation();

    const law1 = password.length < 8
    const law2 = !/(.*[a-z])+/.test(password)
    const law3 = !/(.*[A-Z])+/.test(password)
    const law4 = !/(.*\d)+/.test(password)
    return <ul>
        <li>
            <span className={!law1?` d-none`:`text-danger`}><CloseIcon/></span>
            <span className={law1?` d-none`:`text-success`}><CheckIcon/></span>
            {t('PROFILE.MESSAGE.PASSWORD.REQUIREMENTS.UPPERCASE')}
        </li>
        <li>
            <span className={!law2?` d-none`:`text-danger`}><CloseIcon/></span>
            <span className={law2?` d-none`:`text-success`}><CheckIcon/></span>
            {t('PROFILE.MESSAGE.PASSWORD.REQUIREMENTS.LOWERCASE')}
        </li>
        <li>
            <span className={!law3?` d-none`:`text-danger`}><CloseIcon/></span>
            <span className={law3?` d-none`:`text-success`}><CheckIcon/></span>
            {t('PROFILE.MESSAGE.PASSWORD.REQUIREMENTS.NUMBERS')}
        </li>
        <li>
            <span className={!law4?` d-none`:`text-danger`}><CloseIcon/></span>
            <span className={law4?` d-none`:`text-success`}><CheckIcon/></span>
            {t('PROFILE.MESSAGE.PASSWORD.REQUIREMENTS.LENGTH')}
        </li>
    </ul>
}
export default PasswordChecker